<script lang="ts">
import { defineComponent } from 'vue'

import { CricketStatId, Participant } from '@collector/sportsapi-client-legacy'
import ParticipantComponent from '@mobile/components/Participant/Participant.vue'
import { ProbableLinkedParticipant } from '@mobile/views/Relation/Shared/RelationDependencies/types'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'

import { useCricketConfiguration } from '../../CricketRelationDependencies/useCricketConfiguration'
import ResultWicketsStat from './LiveViewHeaderStats/ResultWicketsStat.vue'

export default defineComponent({
  components: {
    ParticipantComponent,
    ResultWicketsStat,
  },
  setup() {
    const {
      probableFirstParticipant,
      probableLinkedFirstParticipant,
      probableSecondParticipant,
      probableLinkedSecondParticipant,
    } = useEventInjections()
    const { activeParticipant } = useCricketConfiguration()

    function isParticipantActive(
      participant: ProbableLinkedParticipant,
    ): boolean {
      const { id: activeParticipantId } = activeParticipant.value
        .participant as Participant
      const { id: participantId } = participant.getParticipant().value

      return activeParticipantId === participantId
    }

    return {
      CricketStatId,
      activeParticipant,
      isParticipantActive,
      probableFirstParticipant,
      probableLinkedFirstParticipant,
      probableSecondParticipant,
      probableLinkedSecondParticipant,
    }
  },
})
</script>

<template>
  <div class="flex items-center space-x-2 px-2 py-1">
    <div
      class="flex h-8 w-32 items-center justify-start md:w-36 lg:w-48 xl:w-56"
    >
      <ParticipantComponent :participant="probableFirstParticipant" />
    </div>
    <div
      v-if="activeParticipant.participant"
      class="flex h-8 flex-1 flex-row items-center justify-between"
    >
      <div class="flex items-center space-x-2">
        <ResultWicketsStat
          v-if="isParticipantActive(probableLinkedFirstParticipant)"
          :participant="activeParticipant.participant"
        />
      </div>

      <div class="flex items-center space-x-2">
        <ResultWicketsStat
          v-if="isParticipantActive(probableLinkedSecondParticipant)"
          :participant="activeParticipant.participant"
        />
      </div>
    </div>
    <div
      class="flex h-8 w-32 flex-row items-center justify-end md:w-36 lg:w-48 xl:w-56"
    >
      <ParticipantComponent
        :participant="probableSecondParticipant"
        :reverse="true"
      />
    </div>
  </div>
</template>
